import { Injectable } from '@angular/core'
import { Subject } from 'rxjs'
import { NavAction } from './nav-item.interface'

// Relays clicks on nav items that perform an action (e.g. open a pullout) instead of navigating
@Injectable({
    providedIn: 'root',
})
export class SidebarNavActionService {
    #actions = new Subject<NavAction>()

    readonly actions$ = this.#actions.asObservable()

    trigger(action: NavAction): void {
        this.#actions.next(action)
    }
}
